import { companyRequest } from '@/company/api';
import { workspaceApi } from './api';
import type { CompanyConnectionItem, CompanyConnections } from './types';

export type ConnectionAudience = 'private' | 'company';
export type ScopedConnectionItem = CompanyConnectionItem & { audience: ConnectionAudience };
export type ScopedConnections = Omit<CompanyConnections, 'items'> & {
  items: ScopedConnectionItem[];
  companySetup: { available: boolean; reason?: string };
};
const normalize = (value: CompanyConnections): ScopedConnections => ({
  ...value,
  companySetup: (value as ScopedConnections).companySetup ?? value.setup,
  items: value.items.map((item) => ({
    ...item,
    audience: (item as ScopedConnectionItem).audience ?? 'company',
  })),
});
export const connectionApi = {
  list: () => workspaceApi.connections().then(normalize),
  reconcile: () => workspaceApi.reconcileConnections().then(normalize),
  session: (item: ScopedConnectionItem, attemptId?: string) =>
    companyRequest<{ connectLink: string; expiresAt: string }>(
      `/api/v1/company/connections/${encodeURIComponent(item.id)}/session`,
      'POST',
      { audience: item.audience, ...(item.id.startsWith('pipedream:') ? { attemptId } : {}) },
    ),
  disconnect: workspaceApi.disconnect,
};
export const connectionKey = (item: ScopedConnectionItem) =>
  `${item.audience}:${item.id}${item.id.startsWith('pipedream:') && item.connectionId ? ':' + item.connectionId : ''}`;
/** Whether this entry is connecting, for whichever audience the connect sheet continued with. */
export const isConnecting = (busy: string | null, item: ScopedConnectionItem) =>
  busy !== null &&
  (['private', 'company'] as const).some(
    (audience) => connectionKey({ ...item, audience }) === busy,
  );
